import { render, staticRenderFns } from "./ProductListContainer.vue?vue&type=template&id=0ae7c8f0&"
import script from "./ProductListContainer.vue?vue&type=script&lang=ts&"
export * from "./ProductListContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports